import script from "./SharedDocuments3.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedDocuments3.vue?vue&type=script&setup=true&lang=js"

import "./SharedDocuments3.vue?vue&type=style&index=0&id=15c5e44e&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c5e44e"]])

export default __exports__